const cards = [
  {
    title: '某顶流艺人深夜被拍密会神秘女子',
    tag: '娱乐圈',
    hot: true,
    time: '3小时前',
    summary: '据知情人士爆料，该艺人近期频繁出入某高档小区，疑似新恋情曝光，粉丝圈已炸锅。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20paparazzi%20night%20scene%20with%20blurred%20figures%20near%20luxury%20apartment%20building%2C%20moody%20noir%20lighting%2C%20deep%20crimson%20and%20black%20tones%2C%20cinematic%20photography%2C%20mysterious%20vibe%2C%20dramatic%20shadows&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    title: '知名网红带货翻车，粉丝集体退款',
    tag: '网红圈',
    hot: true,
    time: '5小时前',
    summary: '某百万粉丝网红直播带货产品质量遭质疑，大量购买者晒图维权，品牌方紧急回应。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20a%20livestreaming%20setup%20with%20products%20scattered%2C%20ominous%20red%20glow%2C%20moody%20atmosphere%2C%20product%20boxes%20in%20shadow%2C%20cinematic%20noir%20lighting%2C%20high%20contrast%2C%20professional%20photography&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    title: '某公司内部聊天记录外泄引热议',
    tag: '社会事件',
    hot: false,
    time: '7小时前',
    summary: '一份标注为某科技公司高管的内部群聊记录在网络流传，涉及敏感人事变动，真实性待核实。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20office%20scene%20with%20glowing%20computer%20screen%20showing%20encrypted%20messages%2C%20leaked%20documents%20aesthetic%2C%20dramatic%20noir%20lighting%2C%20crimson%20shadows%2C%20corporate%20mystery%20theme%2C%20cinematic%20composition&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    title: '选秀节目黑幕录音曝光，制作人回应',
    tag: '娱乐圈',
    hot: true,
    time: '9小时前',
    summary: '一段疑似选秀节目导演与选手对话的录音片段流出，涉及内定名次与利益输送指控。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20stage%20with%20spotlight%20and%20microphone%2C%20behind%20the%20scenes%20drama%2C%20moody%20cinematic%20lighting%2C%20red%20and%20black%20color%20scheme%2C%20mysterious%20atmosphere%2C%20professional%20editorial%20photography&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    title: '知名博主被扒抄袭国外内容长达两年',
    tag: '网红圈',
    hot: false,
    time: '11小时前',
    summary: '网友整理对比图曝光某知识区博主系统性搬运翻译海外内容，目前该博主已关闭评论区。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20two%20overlapping%20screens%20showing%20similar%20content%2C%20plagiarism%20investigation%20theme%2C%20dramatic%20noir%20lighting%2C%20crimson%20highlights%2C%20professional%20detective%20atmosphere&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    title: '某地夜店打架事件监控视频全网疯传',
    tag: '社会事件',
    hot: true,
    time: '14小时前',
    summary: '一段夜店门口冲突的监控画面引发热议，涉事人员身份被扒，警方已介入调查。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20nightclub%20exterior%20with%20neon%20lights%20and%20security%20cameras%2C%20moody%20atmosphere%2C%20dramatic%20crimson%20and%20black%20lighting%2C%20urban%20night%20scene%2C%20cinematic%20noir%20photography&width=800&height=500&seq=card-06&orientation=landscape',
  },
  {
    title: '夫妻档网红宣布离婚，双方各执一词',
    tag: '网红圈',
    hot: false,
    time: '16小时前',
    summary: '曾以恩爱夫妻人设走红的网红CP突然宣布分居，双方社交媒体隔空互撕，细节逐步曝光。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20two%20separated%20silhouettes%20against%20a%20split%20background%2C%20relationship%20drama%20theme%2C%20moody%20noir%20lighting%2C%20crimson%20and%20dark%20tones%2C%20cinematic%20composition&width=800&height=500&seq=card-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门爆料</h2>
            <p className="text-sm text-foreground-500">最新最热的吃瓜内容，持续追踪更新</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.map((card, i) => (
              <article key={i} className="bg-background-100 rounded-lg overflow-hidden border border-background-300/40 hover:border-background-300/70 transition-all duration-200 group">
                <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading={i > 5 ? "lazy" : undefined}
                  />
                  {card.hot && (
                    <span className="absolute top-3 left-3 px-2 py-1 rounded text-[10px] font-medium bg-primary-500 text-background-50">
                      HOT
                    </span>
                  )}
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-[10px] px-2 py-0.5 rounded-full bg-secondary-500/15 text-secondary-400">{card.tag}</span>
                    <span className="text-xs text-foreground-400">{card.time}</span>
                  </div>
                  <h3 className="font-heading text-base text-foreground-900 mb-2 group-hover:text-primary-400 transition-colors">{card.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{card.summary}</p>
                </div>
              </article>
            ))}
          </div>
          <div className="text-center mt-8">
            <a href="#topics" className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-600 hover:text-foreground-800 border border-background-300/60 rounded-lg transition-all duration-200 text-sm cursor-pointer">
              查看更多爆料
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}